import React, { memo } from "react";
import { View } from "tamagui";

import { MySchedule } from "./components/MySchedule";

export const MyCalendar = memo(() => {
  return (
    <View flex={1} bg="$brandParchment">
      <MySchedule />
    </View>
  );
});
